import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import { useConstitutionModal } from '../context/ConstitutionModalContext';
import ConstitutionModalScriptureView from './ConstitutionModalScriptureView';
import ConstitutionModalMovementsView from './ConstitutionModalMovementsView';

const ConstitutionModalBody: FC = () => {
  const { data } = useConstitutionModal();

  return (
    <Modal.Body>
      <div className="nk-modal">
        {data.scriptureView ? (
          <ConstitutionModalScriptureView />
        ) : (
          <ConstitutionModalMovementsView />
        )}
      </div>
    </Modal.Body>
  );
};

export default ConstitutionModalBody;
